import axios, { AxiosError, AxiosHeaders, AxiosRequestConfig } from "axios";
import { AuthService } from "services/Auth";
import { HTTP_METHOD } from "./APIBase.d";
import { invalidOtpString, otpRequiredString } from "./User";

abstract class APIBaseService {
  USER_KEY: string | undefined = "access_token";
  REFRESH_KEY: string | undefined = "refresh_token";
  protected rootUrl: string | undefined = process.env.REACT_APP_API_URL;
  protected abstract endpoint: string;
  protected call = async (
    path: string,
    method: HTTP_METHOD,
    body: any | FormData = null,
    otp?: string | null,
    addtionalOptions: { [key: string]: any } = {},
  ) => {
    const authService = new AuthService();
    const accessToken = authService.getCurrentUser();

    const requestHeaders = new AxiosHeaders();
    requestHeaders.set({
      "Content-Type": "application/json",
      "requesting-application": "ForeSite",
      Authorization: accessToken,
    });

    if (otp) {
      requestHeaders.set({
        OTP: otp,
      });
    }

    let options: AxiosRequestConfig = {
      method,
      headers: requestHeaders,
      ...addtionalOptions,
    };

    if ([HTTP_METHOD.POST, HTTP_METHOD.PUT].includes(method) && body) {
      options.data = JSON.stringify(body);
    }

    try {
      const res = await axios(
        `${this.rootUrl}/${this.endpoint}/${path}`,
        options,
      );
      return res;
    } catch (error: AxiosError | any) {
      console.log(error);
      const errorMessage =
        error.response?.data?.message?.error ??
        error.response?.data?.message ??
        "";

      if (errorMessage === otpRequiredString) {
        console.log("OTP code required");
        return error;
      }

      if (errorMessage === invalidOtpString) {
        console.log("Invalid OTP code");
        return error;
      }

      throw new Error(errorMessage);
    }
  };
}

export default APIBaseService;
